const config = {
    development: {
      apiUrl: 'http://localhost:8000/backend/',
    },
    production: {
      apiUrl: 'https://www.stablerecords.cz/backend/',
    },
  };

export default config;

  